import { Injectable } from '@angular/core';
import { ModalOptions, ModalService, SimpleModalOptions } from '@healthcatalyst/cashmere';

@Injectable({
    providedIn: 'root'
})
export class IngestionDeleteConfirmationModalService {
    constructor(private modalService: ModalService) {}

    openConfirmDelete(rawMode: string, entityName: string, schemaName?: string) {
        const simpleOptions: SimpleModalOptions = {
            icon: 'icon-trash',
            headerText: 'Delete Job?',
            messageHTML: `Are you sure you want to delete this <strong>${rawMode}</strong> job from <strong>${this.buildEntitySchemaName(
                entityName,
                schemaName
            )}</strong>?`,
            confirmButtonText: `Delete job`,
            footerTooltipText: 'Any queued jobs will still run.'
        };

        const options: ModalOptions = {
            ignoreEscapeKey: true,
            ignoreOverlayClick: true,
            size: 'md'
        };

        this.modalService.allowMultiple = true;
        return this.modalService.confirmDestructive(simpleOptions, options);
    }

    private buildEntitySchemaName(entityName: string, schemaName?: string): string {
        const message = schemaName ? `${schemaName}.${entityName}` : entityName;
        return message;
    }
}
